module.exports = __webpack_public_path__ + "static/media/1.ff30eac4.mp3";